import { WishListItem } from '../../../Reducers/WishList.reducer';

export const mapToAddTGtmItem = (item: WishListItem) => {
  return {
    articleNumber: item.product.id,
    quantity: item.quantity ?? 1,
  };
};

export const handleApiResponse = async (response: Response) => {
  if (!response.ok) {
    throw new Error('API request failed');
  }
  return await response.json();
};
